/**
 * Created by Ning Jiang on 2021-05-04.
 */

import {DeadwoodRipParsedData} from "./DeadwoodRipParsedData";
import {FeatureBuyData, IDeadwoodRipInitData, ISymbolValues} from "./IDeadwoodRipData";
import {DeadwoodRipDataParser} from "./DeadwoodRipDataParser";

export class DeadwoodRipParsedInitData extends DeadwoodRipParsedData {

    public readonly symbolValues:ISymbolValues;
    public readonly isRestoreState:boolean;
    public readonly featureBuyTimesBetValue:FeatureBuyData[];

    constructor(rawData:IDeadwoodRipInitData, parser:DeadwoodRipDataParser) {
        super(rawData, parser);

        this.symbolValues = rawData.symbolValues;
        this.isRestoreState = rawData.isRestoreState;
        this.featureBuyTimesBetValue = rawData.featureBuyTimesBetValue;
    }
}